import { render, staticRenderFns } from "./RankingModal.vue?vue&type=template&id=7b5650ac&"
import script from "./RankingModal.vue?vue&type=script&lang=js&"
export * from "./RankingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports